//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useContext } from 'react';
import { useParams   } from 'react-router';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Add, Cancel, Save, ToggleOn, ToggleOff } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer.jsx';
import { ExpressionContext } from '../ExpressionContext/ExpressionContext';

// === API ===
import { on, removeListener, sendMessage } from 'api/prokey/prokey.websocket';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function TagView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { rule_id } = useParams();

  const { } = useContext( ExpressionContext );

  const [ tags , setTags ] = useState( {} );
  const [ is_required_document , setIsRequiredDocument ] = useState( false );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn: 2,
      gridRow: 1,
      width        : '70rem'  ,
      overflow     : 'hidden' ,
      padding: '1rem',
      borderRadius : '1rem'   ,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    container_exp: {
      height       : '100%'   ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      borderRadius : '1rem'   ,
    },
    container_exp_2: {
      width    : '100%' ,
      height   : 'calc( 100% - 4rem )' ,
      overflow : 'auto' ,
      backgroundColor: theme.palette.background.secondary[theme.palette.mode],
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
    border_1: {
      display: 'flex',
      borderRadius: '1rem',
      width: '100%',
    },
    button_save: {
      width  : '3rem',
      height : '3rem',
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.primary[theme.palette.mode] + getHexAlpha(50),
        color: 'white',
      }
    },
    button_toggle: {
      width  : '3rem',
      height : '3rem',
      fontSize: 40,
    },
    button_cancel: {
      width  : '3rem',
      height : '3rem',
      backgroundColor: theme.palette.error.main,
      color: 'white',
    },
  }

  const CONTAINER = {
    style: _styles.container,
  };
  const HEADER = {
    style: _styles.header,
  };
  const BUTTON_SAVE = {
    sx: _styles.button_save,
    children: <Save />,
    onClick: onClick_Save,
  };
  const BUTTON_TOGGLE = {
    sx: _styles.button_toggle,
    onClick: onClick_Toggle,
  };
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------    
    function listener(data) {
      //-----------------------------------------------------------------
      setTags( data.rule.tags || {} );
    }

    on( 'ANALYTICS_RULE' , listener );
    
    const message = JSON.stringify( { type: 'ANALYTICS_RULE_REQUEST', data: { id: rule_id } } );
    sendMessage( message );

    return () => {
      removeListener( 'ANALYTICS_RULE' , listener );
    };
  }, [] ); // empty dependency = called only once at startup

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Save() {
    //-----------------------------------------------------------------
    const tags_new = { ...tags, is_required_document };
  }

  //-----------------------------------------------------------------
  function onClick_Toggle() {
    //-----------------------------------------------------------------
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <div { ...HEADER }>
          Tags:
          <Spacer fill />
          {/* <Tooltip title='Save rule' placement='top'>
            <IconButton { ...BUTTON_SAVE } />
          </Tooltip> */}
        </div>
        <Spacer />
        <Spacer height='2rem' />
        <Tooltip size='large' title={<h3>Set to true true if rule is checking for a required document.</h3>} placement='bottom'>
          <FormControlLabel control={<Checkbox defaultChecked={tags?.is_required_document} onChange={(e)=>setIsRequiredDocument(e.target.checked)} />} label="Is required document" />
        </Tooltip>
        <Spacer height='2rem' />
      </div>
    );
  }

  //#endregion

  return display();
}
